export default {
  PAYMENT_TERMS_LIST: "Liste des termes de paiement",
  ADD_PAYMENT_TERM: "Ajouter un terme de paiement",
  EDIT_PAYMENT_TERM: "Modifier un terme de paiement",
  PAYMENT_TERM_ADDED: "Terme de paiement ajouté",
  PAYMENT_TERM_UPDATED: "Terme de paiement modifié",
  PAYMENT_TERM_DELETED: "Terme de paiement supprimé",
  DELETE_THIS_PAYMENT_TERM: "Supprimer ce terme de paiement?",
};
